mobileSize = 800;

$(document).ready(function(){  
 // $(".ticket").attr("href", "https://www.etix.com/ticket/o/4491/pinnacle-iup");
  $(".ticket").attr("href", "https://www.tixr.com/groups/iup/");
  
  // General Message
  $('.generalmessage').prependTo('header');

  $(".mobile-nav-toggle").append("\n    <div></div>\n    <div></div>\n    <div></div>\n    ")
  // Check Window Size
  
  const windowSize = $(window).width();

  if (windowSize < 800) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 801) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
  $('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
   //Signup Input text Reappeare
	 var emailInput = $('.emailInputField input');
	 emailInput.val('Enter email address');
	 emailInput.on("click", function () {
		 ClearDefaultText(this, 'Enter email address');
	 });
	 emailInput.on("blur", function () {
		 if ($.trim($(this).val()) == '') {
			 $(this).val('Enter email address');
		 }
   });
   const fes1 = $('.email-insta-main .emailSignup ');
   fes1.find('.emailInputSubmit a').text('SIGN UP');
   $('.mobile-menu-container').each(function( index ) {
    $(this).wrapInner( "<div class='mobile-menu-bg'></div>" );
  });
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');
  $('.generalmessage').prependTo('header');
   //Signup Input text Reappeare
	 var emailInput = $('.emailInputField input');
	 emailInput.val('Enter email Address');
	 emailInput.on("click", function () {
		 ClearDefaultText(this, 'Enter email Address');
	 });
	 emailInput.on("blur", function () {
		 if ($.trim($(this).val()) == '') {
			 $(this).val('Enter email address');
		 }
   });
});